"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _textStyles = require("../../styles/textStyles"); // eslint-disable-next-line import/prefer-default-export


var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      fonts = _ref$theme.fonts,
      space = _ref$theme.space,
      markdown = _ref$theme.markdown,
      colors = _ref$theme.colors,
      copySize = _ref.copySize;
  return _objectSpread(_objectSpread({}, _textStyles.bodySize[copySize]), {}, {
    'h1, h2, h3, h4': {
      fontFamily: fonts.heading,
      margin: "".concat(space.base, " 0") // ...bodySize['large']

    },
    h1: _objectSpread({}, _textStyles.pageTitleSize.large),
    h2: _objectSpread({}, _textStyles.pageTitleSize.xsmall),
    h3: _objectSpread({
      fontFamily: fonts.body
    }, _textStyles.bodySize.large),
    p: _objectSpread({
      fontFamily: fonts.body
    }, _textStyles.bodySize[copySize]),
    li: {
      fontFamily: fonts.body
    },
    a: {
      color: colors[markdown.linkColor],
      '&:hover': {
        color: colors[markdown.linkColorHover],
        textDecoration: markdown.linkHoverTextDecoration
      }
    },
    strong: {
      fontWeight: 'bold',
      em: {
        fontFamily: markdown.famillyBoldItalic
      }
    },
    em: {
      fontStyle: 'italic',
      fontFamily: markdown.famillyItalic,
      strong: {
        fontFamily: markdown.famillyBoldItalic
      }
    }
  });
});
exports.Wrapper = Wrapper;